/**
 * 页面标题管理工具
 */
class TitleManager {
  constructor() {
    this.defaultTitle = "小炮庄";
    this.titleSuffix = " - 小炮庄";
  }

  /**
   * 设置页面标题
   * @param {string} title - 页面标题
   * @param {boolean} withSuffix - 是否添加后缀，默认true
   */
  setTitle(title, withSuffix = true) {
    if (!title) {
      document.title = this.defaultTitle;
      return;
    }
    
    document.title = withSuffix ? title + this.titleSuffix : title;
  }

  /**
   * 获取当前页面标题
   */
  getTitle() {
    return document.title;
  }

  /**
   * 重置为默认标题
   */
  resetTitle() {
    document.title = this.defaultTitle;
  }

  /**
   * 根据路由信息设置标题
   * @param {Object} route - Vue路由对象
   */
  setTitleFromRoute(route) {
    if (route.meta && route.meta.title) {
      this.setTitle(route.meta.title, false); // meta.title已包含完整标题
    } else {
      this.resetTitle();
    }
  }

  /**
   * 动态设置标题（支持模板变量）
   * @param {string} template - 标题模板，如 "商品详情 - {productName}"
   * @param {Object} data - 数据对象
   */
  setDynamicTitle(template, data = {}) {
    let title = template;
    
    // 替换模板变量
    Object.keys(data).forEach(key => {
      const regex = new RegExp(`{${key}}`, 'g');
      title = title.replace(regex, data[key] || '');
    });
    
    this.setTitle(title, false);
  }
}

// 创建单例实例
const titleManager = new TitleManager();

// Vue插件安装方法
titleManager.install = function(Vue) {
  Vue.prototype.$titleManager = titleManager;
  
  // 添加全局方法
  Vue.prototype.$setTitle = titleManager.setTitle.bind(titleManager);
  Vue.prototype.$resetTitle = titleManager.resetTitle.bind(titleManager);
  Vue.prototype.$setDynamicTitle = titleManager.setDynamicTitle.bind(titleManager);
};

export default titleManager;
